import { Component } from 'preact'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import Category from './Category'
import CategoryDefaultSetting from './CategoryDefaultSetting'

const SortableList = SortableContainer(({ children }) => <ul class='sortable-curated-topics-list'>{children}</ul>)
const SortableItem = SortableElement(({ children }) => <li class='sortable-curated-topic'>{children}</li>)

const tabs = data => Object.keys(data).reduce((result, key) => result.concat(data[key]), [])
const names = {
  'categories': 'Category',
  'recent_active': 'Recently active',
  'unanswered': 'Help others'
}

class TabsConfigurator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tabs: props.tabs
    }
  }

  updateTab (idx, field, value) {
    let data = this.state.tabs
    data[idx][field] = value
    this.setState({ tabs: data })
  }

  componentDidUpdate () {
    this.props.onChange(this.state.tabs)
  }

  render (props, state) {
    const categoryTabIdx = state.tabs.findIndex(tab => tab.phrase_suffix === 'categories')
    const categoryTab = state.tabs[categoryTabIdx]

    return <div class='tabs-configurator'>
      <div>
        <label>Tabs settings</label>
        <p>
          You can customise tabs by reordering, renaming, and setting visibility. <br />
          <strong>Tip:</strong> If you use quick links for your categories, it is recommended to not use the category tab as the first tab
        </p>
      </div>
      <div class='table'>
        <div class='tab head'>
          <label>Tab</label>
          <label>Customised tab name</label>
          <label>Visibility</label>
        </div>
        <SortableList useDragHandle onSortEnd={(result) => this.setState({
          tabs: arrayMove(state.tabs, result.oldIndex, result.newIndex)
        })} >
          { tabs(state.tabs).map((tab, idx) => <SortableItem index={idx} key={idx}>
            <Category
              title={names[tab.phrase_suffix]}
              phrase={tab.phrase}
              enabled={tab.enabled}
              onChange={(value, field) => this.updateTab(idx, field, value)}
            />
          </SortableItem>) }
        </SortableList>
      </div>
      {
        categoryTab.enabled ? (
          <CategoryDefaultSetting
            collapsed={categoryTab.collapsed}
            onChange={(value) => this.updateTab(categoryTabIdx, 'collapsed', value)}
          />
        ) : null
      }
    </div>
  }
}

export default TabsConfigurator
